import { CdkTrapFocus } from '@angular/cdk/a11y';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, computed, ElementRef, input, output, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FilterSavedState } from '@src/suite/common/store/inline-filter/inline-filter.models';

import { ClickStopPropagationDirective, EnterStopPropagationDirective, SpaceStopPropagationDirective } from '../../../directives/stop-propagation';
import { SectionFilterComponent } from '../section-filter/section-filter';

const DEFAULT_POSITIONS: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
];

@Component({
    selector: 'st-filter-trigger',
    imports: [
        CdkConnectedOverlay,
        CdkOverlayOrigin,
        CdkTrapFocus,
        ClickStopPropagationDirective,
        EnterStopPropagationDirective,
        MatIcon,
        MatIconButton,
        MatTooltip,
        SectionFilterComponent,
        SpaceStopPropagationDirective,
    ],
    templateUrl: './filter-trigger.html',
    styleUrl: './filter-trigger.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-filter-trigger',
    },
})
export class FilterTriggerComponent {
    readonly config = input<StorytellingFilterDefinition[]>([]);
    readonly state = input<FilterSavedState>({});
    readonly disabled = input<boolean>(false);
    readonly tooltip = input<string>('Filter');
    /** Override the CDK overlay origin. Defaults to the internal icon button. */
    readonly overlayOrigin = input<CdkOverlayOrigin | null>(null);
    /** Override the connected-overlay positions. Defaults to anchored below the origin's start edge. */
    readonly overlayPositions = input<ConnectedPosition[] | null>(null);

    readonly stateChange = output<FilterSavedState>();
    readonly save = output<void>();
    readonly revert = output<void>();
    readonly clear = output<void>();

    readonly open = signal(false);
    readonly resolvedPositions = computed(() => this.overlayPositions() ?? DEFAULT_POSITIONS);
    private readonly triggerButton = viewChild<ElementRef<HTMLButtonElement>>('triggerButton');

    toggle() {
        this.open.update(v => !v);
    }

    close() {
        this.open.set(false);
    }

    restoreFocus() {
        this.triggerButton()?.nativeElement?.focus?.();
    }

    onEscPress(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.close();
            this.restoreFocus();
        }
    }
}
